import {isEmpty, isNil, isObject} from 'lodash'

export const getValue = (value, options, multi) => {
  if (isNil(value)) return null
  return multi
      ? getMultiValue(value, options)
      : getSingleValue(value, options)
}

const getSingleValue = (value, options) => {
  return isObject(value)
      ? value
      : isEmpty(options) ? null : options.find(option => option.value === value)
}

export const getMultiValue = (value, options) => {
  if (!isObject(value)) {
    if (!isNil(value) && typeof value === 'string' && value.indexOf(';') > 0) {
      const splitValues = value.split(';')
      value = splitValues.map(sv => {
        return {label: sv, value: sv}
      })
    } else {
      value = [value]
    }
  }

  return (value.length > 0 && isObject(value[0]))
      ? value
      : isEmpty(options) ? null : options.filter(option => value.includes(option.value))
}

export const getStyle = (key, styles, getDefaults) => (provided, state) => {
  let style = {
    ...provided,                      // style provided by react-select
    ...getDefaults(provided, state),  // style provided by this component
  }

  // style optionally provided by the owner
  if (styles) {
    const propStyle = styles[key]
    if (propStyle) {
      style = {
        ...style,
        ...propStyle(style, state),
      }
    }
  }

  return style
}

export const isOptionValid = (options, optionKey) => {
  if (isNil(optionKey))
    return true

  return !isNil(options) && options.some(opt => opt.key === optionKey)
}

export const ensureOptionExists = (options, optionKey) => {
  return isOptionValid(options, optionKey)
    ? options
    : [
      ...options,
      getInvalidOption(optionKey),
    ]
}

export const getFieldOption = (options, optionKey) => {
  return isOptionValid(options, optionKey)
    ? optionKey
    : getInvalidOption(optionKey)
}

export const getInvalidOption = (optionKey) => {
  return {
    key: optionKey,
    value: optionKey,
    label: '(Invalid)',
  }
}